import { render, staticRenderFns } from "./ContactEn.vue?vue&type=template&id=150480fe"
import script from "./ContactEn.vue?vue&type=script&lang=js"
export * from "./ContactEn.vue?vue&type=script&lang=js"
import style0 from "./ContactEn.vue?vue&type=style&index=0&id=150480fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports